'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleMenuDropdown = exports.goMenu = exports.goSignUp = exports.goLogin = exports.goBrandPath = exports.goSerasaConsumidor = exports.readNotifications = exports.unreadNotifications = exports.notifications = exports.notification = exports.logout = exports.reset = exports.metric = exports.signUp = exports.login = exports.product = exports.brand = exports.gradient = exports.menus = exports.config = exports.init = exports.analyticsEvent = undefined;

var _bifrost = require('@ecs/bifrost');

var _bifrost2 = _interopRequireDefault(_bifrost);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _types = require('./types');

var _constants = require('./constants');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsEvent = exports.analyticsEvent = function analyticsEvent(label, value) {
  if (window.dataLayer == null) {
    return;
  }

  var state = _store2.default.getState();

  window.dataLayer.push({
    event: 'event',
    category: state.metric.category || 'header-' + state.product,
    action: 'header',
    label: label,
    value: value
  });
};

var init = exports.init = function init(state) {
  return {
    type: _types.INIT,
    payload: state
  };
};

var config = exports.config = function config(newConfig) {
  return {
    type: _types.CONFIG,
    payload: newConfig
  };
};

var menus = exports.menus = function menus(newMenus) {
  return {
    type: _types.MENUS,
    payload: newMenus
  };
};

var gradient = exports.gradient = function gradient(newGradient, newColor) {
  return {
    type: _types.GRADIENT,
    payload: {
      gradient: newGradient,
      color: newColor
    }
  };
};

var brand = exports.brand = function brand(newBrand) {
  return {
    type: _types.BRAND,
    payload: newBrand
  };
};

var product = exports.product = function product(newProduct) {
  return {
    type: _types.PRODUCT,
    payload: newProduct
  };
};

var login = exports.login = function login(logged, user) {
  return {
    type: _types.LOGGED,
    payload: {
      logged: logged,
      user: logged ? user : null
    }
  };
};

var signUp = exports.signUp = function signUp(newSignUp) {
  return {
    type: _types.SIGNUP,
    payload: newSignUp
  };
};

var metric = exports.metric = function metric(newMetric) {
  return {
    type: _types.METRIC,
    payload: newMetric
  };
};

var reset = exports.reset = function reset(newStore) {
  return {
    type: _types.RESET,
    payload: newStore
  };
};

var logout = exports.logout = function logout() {
  var state = _store2.default.getState();

  var token = state.profile.token;

  analyticsEvent('logout');

  _bifrost2.default.logout(token, function () {
    if (typeof state.logout.callback === 'function') {
      state.logout.callback();
    } else {
      document.location.reload();
    }

    _store2.default.dispatch({ type: _types.LOGOUT });
  });
};

var notification = exports.notification = function notification(active) {
  return {
    type: _types.NOTIFICATION,
    payload: active
  };
};

var notifications = exports.notifications = function notifications() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  var state = _store2.default.getState();
  var _state$heimdall = state.heimdall,
      ecred = _state$heimdall.ecred,
      endpoints = _state$heimdall.endpoints;


  if (state.notification.loading) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.get({ offset: offset, limit: limit }), {
    type: _constants.ECRED
  }, function (err, req) {
    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_ERROR });
      return;
    }

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_SUCCESS,
      payload: req.response.data
    });
  });
};

var unreadNotifications = exports.unreadNotifications = function unreadNotifications() {
  var state = _store2.default.getState();
  var _state$heimdall2 = state.heimdall,
      ecred = _state$heimdall2.ecred,
      endpoints = _state$heimdall2.endpoints;


  if (state.notification.loading || state.notification.unreadLoaded) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.unread, {
    type: _constants.ECRED
  }, function (err, req) {
    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_UNREAD, payload: 0 });
      return;
    }

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_UNREAD,
      payload: req.response.data.count
    });
  });
};

var readNotifications = exports.readNotifications = function readNotifications(id, url, index) {
  var state = _store2.default.getState();
  var _state$heimdall3 = state.heimdall,
      ecred = _state$heimdall3.ecred,
      endpoints = _state$heimdall3.endpoints;


  if (state.notification.loading) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.read(id), {
    method: 'PUT',
    type: _constants.ECRED
  }, function (err, req) {
    window.location.href = url;

    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_READ, payload: state.notification.list });
      return;
    }

    var list = state.notification.list;
    list[index].isRead = true;

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_READ,
      payload: req.response.data
    });
  });
};

var goSerasaConsumidor = exports.goSerasaConsumidor = function goSerasaConsumidor(evt) {
  var state = _store2.default.getState();

  analyticsEvent('logo-sc');

  if (state.config.proxy) {
    state.config.proxy(evt);
  }
};

var goBrandPath = exports.goBrandPath = function goBrandPath(evt) {
  var state = _store2.default.getState();

  if (typeof state.brand.callback === 'function') {
    state.brand.callback(evt);
  }

  return { type: _types.NOOP };
};

var goLogin = exports.goLogin = function goLogin(evt) {
  var state = _store2.default.getState();
  analyticsEvent('entrar');

  if (state.heimdall.dropdown.menu) {
    _store2.default.dispatch(toggleMenuDropdown());
  }

  if (typeof state.login.callback === 'function') {
    state.login.callback(evt);
  }

  return { type: _types.NOOP };
};

var goSignUp = exports.goSignUp = function goSignUp(evt, key) {
  var state = _store2.default.getState();
  analyticsEvent('cadastro_' + key);

  if (state.heimdall.dropdown.menu) {
    _store2.default.dispatch(toggleMenuDropdown());
  }

  if (typeof state.signUp.callback === 'function') {
    state.signUp.callback(evt);
  }

  return { type: _types.NOOP };
};

var goMenu = exports.goMenu = function goMenu(evt, menu) {
  if (menu.scroll) {
    evt.preventDefault();
    var element = document.querySelector(menu.url);

    if (element == null) {
      return { type: _types.NOOP };
    }

    var scrollY = window.scrollY || window.pageYOffset;
    var top = element.getBoundingClientRect().top + scrollY;

    window.scrollTo({
      top: top - (top > 128 ? 56 : top),
      left: 0,
      behavior: 'smooth'
    });
  }

  if (menu.callback) {
    menu.callback(evt);
  }

  return { type: _types.NOOP };
};

/*-------------------------------------------------------------*/
/*                     DROPDOWN                                */
/*-------------------------------------------------------------*/

var toggleMenuDropdown = exports.toggleMenuDropdown = function toggleMenuDropdown() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'menu';

  var state = _store2.default.getState();

  var methodClass = 'add';
  var paddingRightStyle = null;
  var body$ = document.querySelector('body');

  if (state.heimdall.dropdown[menu]) {
    methodClass = 'remove';
  } else {
    paddingRightStyle = window.innerWidth - document.documentElement.clientWidth;
  }

  body$.classList[methodClass]('ecs_hl_overflow');
  body$.style.paddingRight = paddingRightStyle;

  return {
    type: _types.TOGGLE_DROPDOWN,
    payload: menu
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/actions.js
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38